import localeStore from 'stores/locale';

const GREEK_LOCALE = 'el';

function isUsableLanguage(language: string): boolean {
  try {
    ''.toLocaleUpperCase(language);
    return true;
  } catch {
    return false;
  }
}

function resolveContentLanguage(contentLanguage?: string): string {
  const pageLanguage = localeStore.value;

  if (pageLanguage === GREEK_LOCALE || !contentLanguage || !isUsableLanguage(contentLanguage)) {
    return pageLanguage;
  }

  return contentLanguage;
}

function uppercaseInLanguage(value: string, language?: string): string {
  return value.toLocaleUpperCase(resolveContentLanguage(language));
}

export { resolveContentLanguage, uppercaseInLanguage };
